function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { Layout, eachChildren } from "./Layout";
import * as $array from "../util/Array";
import * as $math from "../util/Math";
/**
 * A grid children layout for [[Container]].
 *
 * @see {@link https://www.amcharts.com/docs/v5/concepts/common-elements/containers/#Layout} for more info
 */
export var GridLayout = /*#__PURE__*/function (_Layout) {
  _inherits(GridLayout, _Layout);
  var _super = _createSuper(GridLayout);
  function GridLayout() {
    _classCallCheck(this, GridLayout);
    return _super.apply(this, arguments);
  }
  _createClass(GridLayout, [{
    key: "_afterNew",
    value: function _afterNew() {
      this._setRawDefault("maxColumns", Number.MAX_VALUE);
      _get(_getPrototypeOf(GridLayout.prototype), "_afterNew", this).call(this);
    }
    /**
     * @ignore
     */
  }, {
    key: "updateContainer",
    value: function updateContainer(container) {
      var paddingLeft = container.get("paddingLeft", 0);
      var paddingRight = container.get("paddingRight", 0);
      var paddingTop = container.get("paddingTop", 0);
      var availableWidth = container.maxWidth() - paddingLeft - paddingRight;
      var minCellWidth = availableWidth;
      var maxCellWidth = 1;
      eachChildren(container, function (child) {
        if (child.get("visible") && child.getPrivate("visible") && !child.get("forceHidden")) {
          if (child.get("position") != "absolute") {
            var childWidth = child.width();
            if (childWidth < minCellWidth) {
              minCellWidth = childWidth;
            }
            if (childWidth > maxCellWidth) {
              maxCellWidth = childWidth;
            }
          }
        }
      });
      minCellWidth = $math.fitToRange(minCellWidth, 1, availableWidth);
      maxCellWidth = $math.fitToRange(maxCellWidth, 1, availableWidth);
      var columnCount = 1;
      if (this.get("fixedWidthGrid")) {
        columnCount = availableWidth / maxCellWidth;
      } else {
        columnCount = availableWidth / minCellWidth;
      }
      columnCount = Math.max(1, Math.floor(columnCount));
      columnCount = Math.min(this.get("maxColumns", Number.MAX_VALUE), columnCount);
      var columnWidths = this.getColumnWidths(container, columnCount, maxCellWidth, availableWidth);
      var prevY = paddingTop;
      var column = 0;
      var maxColumnHeight = 0;
      columnCount = columnWidths.length;
      var prevX = paddingLeft;
      eachChildren(container, function (child) {
        if (child.get("position") == "relative" && child.isVisible()) {
          var marginTop = child.get("marginTop", 0);
          var marginBottom = child.get("marginBottom", 0);
          var bounds = child.adjustedLocalBounds();
          var marginLeft = child.get("marginLeft", 0);
          var marginRight = child.get("marginRight", 0);
          var x = prevX + marginLeft - bounds.left;
          var y = prevY + marginTop - bounds.top;
          child.setPrivate("x", x);
          child.setPrivate("y", y);
          prevX += columnWidths[column] + marginRight;
          maxColumnHeight = Math.max(maxColumnHeight, child.height() + marginTop + marginBottom);
          column++;
          if (column >= columnCount) {
            column = 0;
            prevX = paddingLeft;
            prevY += maxColumnHeight;
          }
        }
      });
    }
    /**
     * @ignore
     */
  }, {
    key: "getColumnWidths",
    value: function getColumnWidths(container, columnCount, maxCellWidth, availableWidth) {
      var _this = this;
      var totalWidth = 0;
      var columnWidths = [];
      var column = 0;
      eachChildren(container, function (child) {
        var bounds = child.adjustedLocalBounds();
        if (child.get("position") != "absolute" && child.isVisible()) {
          if (_this.get("fixedWidthGrid")) {
            columnWidths[column] = maxCellWidth;
          } else {
            columnWidths[column] = Math.max(columnWidths[column] | 0, bounds.right - bounds.left + child.get("marginLeft", 0) + child.get("marginRight", 0));
          }
          if (column < container.children.length - 1) {
            column++;
            if (column == columnCount) {
              column = 0;
            }
          }
        }
      });
      $array.each(columnWidths, function (w) {
        totalWidth += w;
      });
      if (totalWidth > availableWidth) {
        if (columnCount > 2) {
          columnCount -= 1;
          return this.getColumnWidths(container, columnCount, maxCellWidth, availableWidth);
        } else {
          return [availableWidth];
        }
      }
      return columnWidths;
    }
  }]);
  return GridLayout;
}(Layout);
Object.defineProperty(GridLayout, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "GridLayout"
});
Object.defineProperty(GridLayout, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Layout.classNames.concat([GridLayout.className])
});